<template>
  <div class="benefit-query-page">
    <div class="form-section">
      <!-- 查询方式卡片 -->
      <div class="form-card">
        <div class="section-title">🔍 查询方式</div>
        <div class="type-row">
          <div
            class="type-btn"
            :class="{ active: queryType === 'imei' }"
            @click="switchType('imei')"
          >IMEI号查询</div>
          <div
            class="type-btn"
            :class="{ active: queryType === 'phone' }"
            @click="switchType('phone')"
          >电话号码查询</div>
        </div>

        <div v-if="queryType === 'imei'" class="input-group">
          <label>设备IMEI号</label>
          <input
            type="text"
            v-model="imei"
            placeholder="请输入IMEI号"
          />
        </div>

        <div v-else class="input-group">
          <label>注册电话号码</label>
          <input
            type="tel"
            v-model="phone"
            placeholder="请输入注册手机号"
          />
        </div>

        <button class="query-btn" @click="handleQuery">
          <van-loading v-if="loading" size="16px" color="#fff" style="margin-right:8px;" />
          查询权益
        </button>
      </div>

      <!-- 查询结果 -->
      <template v-if="result">
        <!-- 设备信息卡 -->
        <div class="device-card">
          <div class="device-header">
            <div class="device-icon">
              <van-icon name="phone-o" size="28" color="#1890ff" />
            </div>
            <div class="device-detail">
              <div class="device-name">{{ result.brand }} {{ result.model }}</div>
              <div class="device-specs" v-if="result.ram_size">{{ result.ram_size }}</div>
              <div class="device-specs" v-if="result.imei">IMEI: {{ result.imei }}</div>
            </div>
          </div>
          <div
            class="validity-badge"
            :class="{ 'validity-badge--inactive': result.status !== 1 }"
          >
            <van-icon
              :name="result.status === 1 ? 'passed' : 'close'"
              :color="result.status === 1 ? '#52c41a' : '#ff4d4f'"
              size="14"
            />
            {{ result.status === 1 ? '生效中' : (result.status_text || '未生效') }}
            <span v-if="result.term_time_start && result.term_time_end">
              &nbsp; {{ result.term_time_start }} ~ {{ result.term_time_end }}
            </span>
          </div>
        </div>

        <!-- 保险权益 -->
        <div
          class="rights-card"
          v-if="result.insurance_interests && result.insurance_interests.length"
        >
          <div class="card-header">
            <div class="section-title">🛡️ 保险权益</div>
            <div class="tag-green" v-if="result.status === 1">生效中</div>
          </div>
          <div
            class="benefit-row"
            v-for="(item, idx) in result.insurance_interests"
            :key="'ins' + idx"
          >
            <span class="row-name">{{ item.name }}</span>
            <span
              class="row-val"
              :class="item.value === '已绑定' ? 'val-green' : 'val-gray'"
            >{{ item.value === '已绑定' ? '✓ 已绑定' : item.value }}</span>
          </div>
        </div>

        <!-- 售后权益 -->
        <div
          class="rights-card"
          v-if="result.after_sale_interests && result.after_sale_interests.length"
        >
          <div class="section-title">🔧 售后权益</div>
          <div
            class="benefit-row"
            v-for="(item, idx) in result.after_sale_interests"
            :key="'svc' + idx"
          >
            <span class="row-name">{{ item.name }}</span>
            <span
              class="row-val"
              :class="item.value && item.value.indexOf('可用') !== -1 ? 'val-green' : 'val-gray'"
            >{{ item.value }}</span>
          </div>
        </div>

        <div class="tips-box">
          <strong>说明：</strong>权益查询仅支持查看，不可在用户端操作。如需激活或售后请前往OPPO门店联系店员。
        </div>
      </template>

      <!-- 无结果 -->
      <div class="empty-wrap" v-if="queried && !result">
        <van-empty description="未查询到相关设备权益信息" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitQuery',
  data() {
    return {
      queryType: 'imei',
      imei: '',
      phone: '',
      loading: false,
      queried: false,
      result: null,
    }
  },
  methods: {
    switchType(type) {
      this.queryType = type
      this.result = null
      this.queried = false
    },
    handleQuery() {
      if (this.queryType === 'imei' && !this.imei.trim()) {
        this.$toast('请输入IMEI号')
        return
      }
      if (this.queryType === 'phone' && !this.phone.trim()) {
        this.$toast('请输入手机号')
        return
      }
      this.loading = true
      this.result = null
      this.queried = false

      const params = this.queryType === 'imei'
        ? { type: 1, imei: this.imei.trim() }
        : { type: 2, phone: this.phone.trim() }

      this.$http.oppoQueryDevice(params)
        .then((res) => {
          this.queried = true
          this.result = (res && res.data) || null
          if (!this.result) {
            this.$toast('未查询到相关设备信息')
          }
        })
        .catch((err) => {
          this.queried = true
          this.$toast((err && err.msg) || '查询失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.benefit-query-page {
  min-height: 100vh;
  background: #f5f5f5;

  .form-section {
    padding: 24px;

    .form-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px 30px 24px;
      margin-bottom: 20px;

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 20px;
      }

      .type-row {
        display: flex;
        gap: 16px;
        margin-bottom: 28px;

        .type-btn {
          flex: 1;
          height: 60px;
          line-height: 60px;
          text-align: center;
          border: 1px solid #d9d9d9;
          border-radius: 12px;
          font-size: 26px;
          color: #666;
          cursor: pointer;
          transition: all 0.2s;

          &.active {
            background: #1890ff;
            color: #fff;
            border-color: #1890ff;
          }
        }
      }

      .input-group {
        margin-bottom: 28px;

        label {
          display: block;
          font-size: 26px;
          color: #888;
          margin-bottom: 12px;
        }

        input {
          width: 100%;
          padding: 20px 24px;
          border: 1px solid #e8e8e8;
          border-radius: 16px;
          font-size: 28px;
          outline: none;
          background: #fafafa;
          box-sizing: border-box;
          color: #333;

          &:focus {
            border-color: #1890ff;
            background: #fff;
          }

          &::placeholder {
            color: #ccc;
          }
        }
      }

      .query-btn {
        width: 100%;
        padding: 26px;
        border: none;
        border-radius: 20px;
        font-size: 30px;
        font-weight: 600;
        cursor: pointer;
        background: linear-gradient(135deg, #1890ff, #36cfc9);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s;

        &:active {
          opacity: 0.85;
        }
      }
    }

    .device-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .device-header {
        display: flex;
        gap: 24px;
        margin-bottom: 24px;

        .device-icon {
          width: 96px;
          height: 96px;
          background: #e6f7ff;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .device-detail {
          flex: 1;

          .device-name {
            font-size: 32px;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 8px;
          }

          .device-specs {
            font-size: 22px;
            color: #999;
            line-height: 1.8;
          }
        }
      }

      .validity-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: #f6ffed;
        border: 1px solid #b7eb8f;
        border-radius: 12px;
        padding: 16px 24px;
        font-size: 24px;
        color: #52c41a;
        font-weight: 600;

        &--inactive {
          background: #fff1f0;
          border-color: #ffa39e;
          color: #ff4d4f;
        }
      }
    }

    .rights-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .section-title {
          margin-bottom: 0;
        }

        .tag-green {
          font-size: 22px;
          color: #52c41a;
          background: #f6ffed;
          border: 1px solid #b7eb8f;
          border-radius: 20px;
          padding: 4px 18px;
        }
      }

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 16px;
      }

      .benefit-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 0;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .row-name {
          font-size: 28px;
          color: #555;
        }

        .row-val {
          font-size: 26px;
          font-weight: 500;

          &.val-green { color: #52c41a; }
          &.val-gray  { color: #bbb; }
        }
      }
    }

    .tips-box {
      background: #f0f5ff;
      border-left: 4px solid #1890ff;
      border-radius: 0 12px 12px 0;
      padding: 20px 24px;
      font-size: 24px;
      color: #0050b3;
      line-height: 1.8;
      margin-bottom: 20px;
    }

    .empty-wrap {
      background: #fff;
      border-radius: 16px;
      padding: 40px 0;
      margin-top: 20px;
    }
  }
}
</style>
